var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.location_href.startsWith('http://127.0.0.1'))?_c('div',[_c('b-checkbox',{attrs:{"switch":""},on:{"change":(v) => _vm.$store.commit('changeDebugMode', v)},model:{value:(_vm.debug),callback:function ($$v) {_vm.debug=$$v},expression:"debug"}},[_vm._v("Debug mode")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }